import React from 'react';
import {
//  fade,
//  ThemeProvider,
  withStyles,
//  makeStyles,
//  createMuiTheme,
} from '@material-ui/core/styles';
//import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const TextFieldCustom = withStyles({
  root: {
    '& .MuiInputBase-root': {
      backgroundColor: '#ffffff',
    },
    '& input:valid + fieldset': {
      borderColor: '#000000',
      borderWidth: 1.0,
    },
    '& input:invalid + fieldset': {
      borderColor: '#ff0000',
      borderWidth: 1.0,
    },
    '& input:valid:focus + fieldset': {
      borderLeftWidth: 6,
      padding: '4px !important', // override inline-style
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#000000',
      borderWidth: 1.0,
    },
    '& .MuiInputLabel-shrink': {
      color: 'inherit'
    },
  },
  //エラーが出るためコメントアウト
  // input: {
  //   '&:focus': {
  //     borderColor: '#ff0000',
  //   }
  // }
})(TextField);

export const textField = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextFieldCustom
    label={label}
    error={touched && invalid}
    helperText={touched && error}
    variant="outlined"
    fullWidth={true}
    InputProps={{
      style: {
        height: '40px',
        // boxShadow: '0px -2px 0px 0px rgba(255, 255, 255, 1.2), 2px 2px 2px 2px rgba(0, 0, 0, 0.2)',
        boxShadow: '0px -1px 0px 0px rgba(255, 255, 255, 1.2), 1px 1px 1px 1px rgba(0, 0, 0, 0.2)'
      }
    }}
    InputLabelProps={{
      shrink: true,
    }}
    {...input}
    {...custom}
  />
);

export const textField2 = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextFieldCustom
    label={label}
    error={touched && invalid}
    helperText={touched && error}
//    variant="outlined"
    fullWidth={true}
    InputProps={{
      style: {
        height: '40px',
        // boxShadow: '0px -2px 0px 0px rgba(255, 255, 255, 1.2), 2px 2px 2px 2px rgba(0, 0, 0, 0.2)',
        boxShadow: '0px -1px 0px 0px rgba(255, 255, 255, 1.2), 1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
      },
      readOnly: true,
    }}
    InputLabelProps={{
      shrink: true,
    }}
    {...input}
    {...custom}
  />
);

export const textField3 = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextFieldCustom
    label={label}
    error={touched && invalid}
    helperText={touched && error}
//    variant="outlined"
    fullWidth={true}
    InputProps={{
      style: {
        height: '40px',
        // boxShadow: '0px -2px 0px 0px rgba(255, 255, 255, 1.2), 2px 2px 2px 2px rgba(0, 0, 0, 0.2)',
//        boxShadow: '0px -1px 0px 0px rgba(255, 255, 255, 1.2), 1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
      },
      readOnly: true,
    }}
    InputLabelProps={{
      shrink: true,
    }}
    {...input}
    {...custom}
  />
);

export const textFieldMax50 = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextFieldCustom
    label={label}
    error={touched && invalid}
    helperText={touched && error}
    variant="outlined"
    fullWidth={true}
    InputProps={{
      inputProps:{maxLength:50},
      style: {
        height: '40px',
        // boxShadow: '0px -2px 0px 0px rgba(255, 255, 255, 1.2), 2px 2px 2px 2px rgba(0, 0, 0, 0.2)',
        boxShadow: '0px -1px 0px 0px rgba(255, 255, 255, 1.2), 1px 1px 1px 1px rgba(0, 0, 0, 0.2)'
      }
    }}
    InputLabelProps={{
      shrink: true,
    }}
    {...input}
    {...custom}
  />
);

export const textFieldMax100 = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextFieldCustom
    label={label}
    error={touched && invalid}
    helperText={touched && error}
    variant="outlined"
    fullWidth={true}
    maxRows='3'
    multiline
    InputProps={{
      inputProps:{maxLength:100},
      style: {
        height: '95px',
        // boxShadow: '0px -2px 0px 0px rgba(255, 255, 255, 1.2), 2px 2px 2px 2px rgba(0, 0, 0, 0.2)',
        boxShadow: '0px -1px 0px 0px rgba(255, 255, 255, 1.2), 1px 1px 1px 1px rgba(0, 0, 0, 0.2)'
      }
    }}
    InputLabelProps={{
      shrink: true,
    }}
    {...input}
    {...custom}
  />
);

export const textFieldGraduation = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextFieldCustom
    label={label}
    error={touched && invalid}
    helperText={touched && error}
    variant="outlined"
    fullWidth={true}
    InputProps={{
      style: {
        height: '40px',
        WebkitBackground: [
          "-webkit-gradient(linear, left top, left bottom, color-stop(0.00, #ffffff), color-stop(1.00, #ffaaaa))",
          "-webkit-linear-gradient(#ffffff, #ffaaaa)"
        ],
        MozBackground: "-moz-linear-gradient(#ffffff, #ffaaaa)",
        OBackground: "-o-linear-gradient(#ffffff, #ffaaaa)",
        msBackground: "-ms-linear-gradient(#ffffff, #ffaaaa)",
        background: "linear-gradient(#ffffff, #ffaaaa)",
      }
    }}
    InputLabelProps={{
      shrink: true,
    }}
    {...input}
    {...custom}
  />
);

export const textFieldShadow = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextFieldCustom
    label={label}
    error={touched && invalid}
    helperText={touched && error}
    variant="outlined"
    fullWidth={true}
    InputProps={{
      style: {
        height: '40px',
        boxShadow: '0px -2px 0px 0px rgba(255, 255, 255, 1.2), 2px 2px 2px 2px rgba(0, 0, 0, 0.2)',
      }
    }}
    InputLabelProps={{
      shrink: true,
    }}
    {...input}
    {...custom}
  />
);

export const textFieldInTables = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextField
    label={label}
    error={touched && invalid}
    helperText={touched && error}
    variant="outlined"
    fullWidth={true}
    InputProps={{
      style: {
        height: '26px',
      }
    }}
    InputLabelProps={{
      shrink: true,
    }}
    {...input}
    {...custom}
  />
);

export const textAria = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextField
    label={label}
    error={touched && invalid}
    helperText={touched && error}
    variant="outlined"
    fullWidth={true}
    InputLabelProps={{
      shrink: true,
    }}
    multiline
    minRows={6}
    {...input}
    {...custom}
  />
);

export const selectBox = ({
  label,
  input: { value, onChange },
  meta: { touched, invalid, error },
  options,
  ...custom
}) => (
  <TextFieldCustom
    label={label}
    error={touched && invalid}
    helperText={touched && error}
    variant="outlined"
    fullWidth={true}
    value={value}
    InputProps={{
      style: {
        height: '40px',
        // boxShadow: '0px -2px 0px 0px rgba(255, 255, 255, 1.2), 2px 2px 2px 2px rgba(0, 0, 0, 0.2)',
        boxShadow: '0px -1px 0px 0px rgba(255, 255, 255, 1.2), 1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
      }
    }}
    InputLabelProps={{
      shrink: true,
    }}
    select
    onChange={(e) => {
      onChange(e.target.value);
    }}
    {...custom}
  >
  {
    options.map((item, index) => {
      return (<MenuItem disabled={item.disabled} value={item.key} key={index}>{item.value}</MenuItem>);
    })
  }
  </TextFieldCustom>
);

export const radioButton = ({
  label,
  input: { value, onChange },
  meta: { touched, invalid, error },
  options,
  ...custom
}) => (
  <FormControl component="fieldset" error={touched && invalid} {...custom}>
    <FormLabel component="legend">{label}</FormLabel>
    <RadioGroup
      row={true}
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
    >
    {
      options.map((item, index) => {
        return (<FormControlLabel value={item.key} control={<Radio size="small" />} label={item.value} key={index} />);
      })
    }
    </RadioGroup>
    {touched && error && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);

export const checkBox = ({
  label,
  input: { value, onChange },
  meta: { touched, invalid, error },
  options,
  ...custom
}) => (
  <FormControl component="fieldset" error={touched && invalid} {...custom}>
    <FormLabel component="legend">{label}</FormLabel>
    <FormGroup
      //row={true}
      value={value}
      onChange={(e) => {
        var ret = [];
        if(value) {
          value.forEach((v) => {
            if(v !== String(e.target.value)) {
              ret.push(v);
            }
          });
        }
        if(e.target.checked) {
          ret.push(e.target.value);
        }
        ret.sort();
        onChange(ret);
      }}
    >
    {
      options.map((item, index) => {
        return (<FormControlLabel value={item.key} control={<Checkbox checked={(value.includes(item.key))} size="small" />} label={item.value} key={index} />);
      })
    }
    </FormGroup>
    {touched && error && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);
